import axios from 'axios';
import {API_URL} from '../constants/index.js';
import {useInterceptor} from './apiUtils';

useInterceptor(axios);

export function getDestinations(params) {
	return axios({
		method: 'get',
		url: `${API_URL}/destinations`,
		params: params
	});
}

export function showDestination(slug, options = {}) {
	return axios({
		method: 'get',
		url: `${API_URL}/destinations/${slug}`,
		skipGlobalError: options.skipGlobalError === true,
	});
}

export function getDistricts(params) {
	return axios({
		method: 'get',
		url: `${API_URL}/districts`,
		params: params
	});
}

export function showDistrict(slug) {
	return axios({
		method: 'get',
		url: `${API_URL}/districts/${slug}`
	});
}

export function getProvinces() {
	return axios({
		method: 'get',
		url: `${API_URL}/provinces`
	});
}

export function showProvince(slug) {
	return axios({
		method: 'get',
		url: `${API_URL}/provinces/${slug}`
	});
}

export function getRegions() {
	return axios({
		method: 'get',
		url: `${API_URL}/regions`
	});
}

export function getTags(params) {
	return axios({
		method: 'get',
		url: `${API_URL}/tags`,
		params: params
	});
}
